import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { AuthenticationService } from "@app/services/authentication.service";
import { Subject } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { AppSettings } from "./app.settings";
import { LanguageOption } from "@app/models/language-option.type";
import { OktaService } from "@modules/okta-login/services/okta.service";
import { OktaOidcService } from "@modules/okta-login/services/okta-oidc.service";
import { RegisterAsNewCustomerModalComponent } from "@modules/order-product/register-as-new-customer-modal/register-as-new-customer.modal";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
   selector: "my-cloud-root",
   templateUrl: "./app.component.html",
   styleUrls: ["./app.component.scss"],
   standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
   private modalService = inject(NgbModal);
   private router = inject(Router);
   appSettings = inject(AppSettings);
   loader = inject(LoadingBarService);
   authService = inject(AuthenticationService);
   oktaService = inject(OktaService);
   oktaOidcService = inject(OktaOidcService);
   private translate = inject(TranslateService);

   private destroyed: Subject<void> = new Subject<void>();

   public isOriginPage: boolean = false;
   public isLoading: boolean = false;

   public ngOnInit(): void {
      // loads all MC_ translations of the stored language in one request
      this.translate.use(this.appSettings.selectedLanguageLocale);

      this.router.events
         .pipe(filter(e => e instanceof NavigationEnd))
         .subscribe((navEnd: NavigationEnd) => {
            this.isOriginPage = navEnd.urlAfterRedirects.startsWith(
               "/ng/origin/"
            );
         });

      // this.loader.value$.subscribe(percentage => {
      //    this.isLoading = percentage > 0 && percentage < 100;
      // });
   }

   public ngOnDestroy(): void {
      this.destroyed.next();
      this.destroyed.complete();
   }

   public get selectedLanguage(): string {
      switch (this.appSettings.selectedLanguage) {
         case "N":
            return "NL";
         case "F":
            return "FR";
         case "E":
         default:
            return "EN";
      }
   }

   public changeLanguage(language: LanguageOption): void {
      this.authService.changeLanguage(language);
   }

   public logout(): void {
      this.oktaService.logout();
   }

   public get isOrgingLoggedIn(): boolean {
      return this.isOriginPage || this.authService.isOriginSsoAuthenticated;
   }

   public get hideOrderProductLoginButtons(): boolean {
      const isOrderProductPage = this.router.url.includes("ng/order-product");
      if (!isOrderProductPage) {
         return false;
      }

      //hide when product selected because updating the url does not trigger this.
      return this.router.url.includes(";product=");
   }

   public login(): void {
      // this.oktaOidcService.setState('redirect', this.router.url);
      this.oktaOidcService.login();
   }

   public register(): void {
      const modalRef = this.modalService.open(
         RegisterAsNewCustomerModalComponent,
         {
            ariaLabelledBy: "modal-basic-title",
            size: "xl",
            scrollable: false
         }
      );

      this.destroyed.subscribe(_ => modalRef.dismiss());

      modalRef.result.then(
         _ => this.oktaOidcService.login(),
         _ => void 0
      );
   }
}
